import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { customerResource } from '@/views/system/customerManage/request';
import detailExportModal from './detailExportModal.vue';
import { personnelDetailsRecord1, policyNoResource, operatorResource } from './request';
import operatingDetail from '../homeManage/operatingDetail.vue';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
  components: {
    detailExportModal,
    operatingDetail
  },
  data() {
    const that = this;
    return {
      exportVisible: false,
      detailVisible: false,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      form: {
        recordType: '',
        operator: undefined,
        policyNo: undefined,
        customerId: undefined,
        time: [],
        name: '',
        idNumber: ''
      },
      columns: [],
      data: [],
      customerList2: [],
      policyNoList: [],
      policyId: undefined,
      personnelDetailsId: undefined,
      operatorList: []
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  async created() {
    const customerList2 = await customerResource({});
    this.customerList2 = customerList2;
    if (customerList2.length == 0) {
      return false;
    }
    let arr = customerList2.filter(item => item.id == Number(sessionStorage.getItem('policyCustomerId')));
    this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('policyCustomerId')) : customerList2[0].id;
    sessionStorage.setItem('policyCustomerId', this.form.customerId);
    this.searchFun();
    await this.operatorResourceFn();
    await this.policyNoResourceFn();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async getDataFun() {
      var _this$form$operator, _this$form$name, _this$form$idNumber;
      let policyItem = this.policyNoList.filter(item => item.policyNo == this.form.policyNo);
      let obj = {
        recordType: this.form.recordType,
        operator: ((_this$form$operator = this.form.operator) === null || _this$form$operator === void 0 ? void 0 : _this$form$operator.trim()) || '',
        // policyNo: this.form.policyNo,
        customerId: this.form.customerId,
        policyId: policyItem.length > 0 ? policyItem[0].id : '',
        name: ((_this$form$name = this.form.name) === null || _this$form$name === void 0 ? void 0 : _this$form$name.trim()) || '',
        idNumber: ((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 || (_this$form$idNumber = _this$form$idNumber.trim()) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.toLocaleUpperCase()) || ''
      };
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = this.form.time.length ? moment(this.form.time[0]).format('YYYY-MM-DD') : undefined;
      obj.endAt = this.form.time.length ? moment(this.form.time[1]).format('YYYY-MM-DD') : undefined;
      const res = await personnelDetailsRecord1(obj);
      this.columns = res.fieldConfig && Array.isArray(res.fieldConfig) && res.fieldConfig.map(item => {
        let obj = item;
        obj.slots = {
          title: item.title
        };
        delete obj.title;
        if (item.dataIndex === 'recordType') {
          obj.scopedSlots = {
            customRender: 'recordType'
          };
        }
        delete obj.title;
        return obj;
      });
      this.columns.push({
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: 'column-action',
        width: 100
      });
      this.pagination.total = res.totalNum;
      this.data = res.items;
    },
    async customerChange() {
      this.form.operator = undefined;
      this.form.policyNo = undefined;
      sessionStorage.setItem('policyCustomerId', this.form.customerId);
      await this.operatorResourceFn();
      await this.policyNoResourceFn();
    },
    async operatorResourceFn() {
      const res = await operatorResource({
        customerId: this.form.customerId
      });
      this.operatorList = res;
    },
    async policyNoResourceFn() {
      const res = await policyNoResource({
        customerId: this.form.customerId
      });
      this.policyNoList = res;
    },
    resetSearch() {
      this.form.recordType = '';
      this.form.operator = undefined;
      this.form.policyNo = undefined;
      this.form.name = undefined;
      this.form.idNumber = undefined;
      this.form.time = [];
      this.searchFun();
    },
    openDetail(record) {
      this.policyId = record.policyId;
      this.personnelDetailsId = record.personnelDetailsId;
      this.detailVisible = true;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};